import { Skeleton } from '@genial/components';
import { Box } from 'native-base';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../components/TableContent';

const createSkeleton = () => (
  <Skeleton width={40 + Math.random() * 50 + '%'} height="inset.xs" borderRadius="sm" />
);

export const DividendHistoryItemLoadingTablet = () => {
  const loadings = [5, 5];

  const itemContent = loadings.map((loadingCountOnRow, rowIndex) => {
    const rowContent = Array.from({ length: loadingCountOnRow }, (_, colIndex) => {
      return (
        <TableContentItemColumn key={`${rowIndex}-${colIndex}`} flex={1} space="stack.nano">
          <TableContentItemText>{createSkeleton()}</TableContentItemText>
          <TableContentItemText>{createSkeleton()}</TableContentItemText>
        </TableContentItemColumn>
      );
    });

    return (
      <Box flexDirection="row" width="full" key={rowIndex}>
        {rowContent}
      </Box>
    );
  });

  itemContent.splice(
    1,
    0,
    <Box
      key="spacer"
      borderBottomColor="neutral.lightest"
      borderBottomWidth="1px"
      paddingTop="inset.xs"
      marginBottom="inset.xs"
      width="full"
    />
  );

  return (
    <TableContent direction="column" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      {itemContent}
    </TableContent>
  );
};
